import React from "react"

import useLazyImport from "hooks/useLazyImport"
import { applyImageCloudinaryTransforms } from "utils/applyCloudinaryTransforms"

import Icon from "icons"
import RichTextContentful from "components/rich-text"

const Carousel = ({ people, thumbNav, elRef, dataId, hideOnPageLoad, ...props }) => {
  const styles = useLazyImport(() => import("./styles"))
  if (!styles) return null

  const { Slider, Slide, Container, Image, SlideContent, Prev, Next, Dots, ImageNav, ImageThumb } =
    styles
  return (
    <div data-exp-id={dataId}>
      <Container
        {...props}
        hideOnPageLoad={hideOnPageLoad}
        ref={elRef}
        totalSlides={people.length}
        naturalSlideWidth={1}
        naturalSlideHeight={1}
        infinite
      >
        <Slider>
          {people.map((person, idx) => (
            <Slide key={person.name} index={idx}>
              <Image
                baseUrl={person.image}
                images={[
                  {
                    screenSize: 1200,
                    transforms: "c_fill,g_auto,w_1080,h_541,q_auto,f_auto,fl_lossy",
                  },
                  {
                    screenSize: 992,
                    transforms: "c_fill,g_auto,w_900,h_604,q_auto,f_auto,fl_lossy",
                  },
                  {
                    screenSize: 768,
                    transforms: "c_fill,g_auto,w_792,h_516,q_auto,f_auto,fl_lossy",
                  },
                  {
                    transforms: "c_fill,g_auto,w_768,h_768,q_auto,f_auto,fl_lossy",
                  },
                ]}
              />
              <SlideContent>
                <div>
                  <h2>{person.name}</h2>
                  <h4>{person.title}</h4>
                  {person.shortBio ? (
                    <RichTextContentful rawRichText={person.shortBio} />
                  ) : (
                    <p>&nbsp;</p>
                  )}
                </div>
              </SlideContent>
            </Slide>
          ))}
        </Slider>
        <Prev>
          <Icon id="play-icon-filled" width={50} height={50} />
        </Prev>
        <Next>
          <Icon id="play-icon-filled" width={50} height={50} />
        </Next>
        {!thumbNav && <Dots />}
        {thumbNav && (
          <ImageNav>
            {people.map((person, idx) => (
              <ImageThumb
                key={person.name}
                slide={idx}
                thumburl={applyImageCloudinaryTransforms(
                  person.image,
                  "c_fill,g_auto,w_30,h_30,q_auto,f_auto,fl_lossy",
                )}
              >
                <span />
              </ImageThumb>
            ))}
          </ImageNav>
        )}
      </Container>
    </div>
  )
}

export default Carousel
